


































































































  import { DateUtils } from '@/commun/utils/date-utils';
  import { DemandesTableauActions } from '@/components/demandes/tableau/actions';
  import {
    DemandesTableauColonnes,
    DemandesTableauColonnesNom,
  } from '@/components/demandes/tableau/demandes-tableau-colonnes';
  import DemandesTableauLigne, {
    creerLigneDemande,
  } from '@/components/demandes/tableau/demandes-tableau-ligne';
  import { DemandesTableauEnteteDesktop } from '@/components/demandes/tableau/entete/desktop';
  import { DemandesTableauEnteteMobile } from '@/components/demandes/tableau/entete/mobile';
  import { ETAT_INITIAL } from '@/domain/models/colonne-tableau-tri-etat-initial';
  import DemandeCours from '@/domain/models/demande-cours';
  import Vue, { PropType } from 'vue';
  import { DataTableHeader } from 'vuetify';

  export default Vue.extend({
    name: 'DemandesTableau',
    components: {
      DemandesTableauActions,
      DemandesTableauEnteteDesktop,
      DemandesTableauEnteteMobile,
    },
    props: {
      afficherBoutonCreerDemande: {
        type: Boolean,
        default: true,
      },
      colonneTriParDefaut: {
        required: false,
        type: String,
        default() {
          return DemandesTableauColonnesNom.Numero;
        },
      },
      colonnesAffichees: {
        required: false,
        type: Array as PropType<Array<DemandesTableauColonnesNom>>,
        default() {
          return [
            DemandesTableauColonnesNom.Numero,
            DemandesTableauColonnesNom.Session,
            DemandesTableauColonnesNom.Type,
            DemandesTableauColonnesNom.Faculte,
            DemandesTableauColonnesNom.CoursProgramme,
            DemandesTableauColonnesNom.Etat,
            DemandesTableauColonnesNom.Actions,
          ];
        },
      },
      demandes: {
        type: Array as PropType<Array<DemandeCours>>,
        default: () => [],
      },
    },
    data: () => ({
      filtreRecherche: '',
      demandesParPage: 10,
      trierDescendant: false,
      colonneATrier: '',
    }),

    computed: {
      colonnes(): DataTableHeader[] {
        return DemandesTableauColonnes(this.$i18n, this.colonnesAffichees);
      },
      lignes(): DemandesTableauLigne[] {
        return this.demandes.map((demande: DemandeCours) =>
          creerLigneDemande(demande, this)
        );
      },
      estTailleMobile(): boolean {
        return !this.$vuetify.breakpoint.smAndUp;
      },
    },
    created() {
      this.trierDescendant = this.$store.getters.trierTableauDescendant;
      if (this.$store.getters.colonneATrier === ETAT_INITIAL) {
        this.colonneATrier = this.colonneTriParDefaut;
      } else {
        this.colonneATrier = this.$store.getters.colonneATrier;
      }
      this.filtreRecherche = this.$store.getters.filtreRecherche;
      this.demandesParPage = this.$store.getters.demandesParPage;
    },
    methods: {
      onNaviguerCreerDemande(): void {
        this.$emit('naviguerCreerDemande');
      },
      onPaginationModifie(event: number): void {
        this.$store.dispatch('modifierNombreDemandesParPageTableau', event);
      },
      onFiltreRechercheModifie(event: string): void {
        this.$store.dispatch('modifierFiltreRechercheTableau', event);
      },
      onTriDescendentModifie(event: any): void {
        this.trierDescendant = event;
        this.$store.dispatch('modifierOrdreTriTableau', this.trierDescendant);
      },
      onColonneTriModifie(event: any): void {
        this.colonneATrier = event;
        this.$store.dispatch('modifierColonneTriTableau', this.colonneATrier);
      },
      customFilter(_value: any, entreeRecherche: string | null, item: any) {
        const valeursItem = {
          numeroDemande: item['numeroDemande'],
          codeSession: item['codeSession'],
          typeDemande: item['typeDemande'],
          codeFaculte: item['codeFaculte'],
          coursProgramme: item['coursProgramme'].join(),
          etatDemande: item['etatDemande'],
          dateDepot: item['dateDepot'].substring(0, 10),
        };
        return Object.values(valeursItem)
          .filter((valeurItem) => valeurItem)
          .some((valeurItem) =>
            valeurItem
              .toString()
              .toUpperCase()
              .includes(entreeRecherche?.toUpperCase() || '')
          );
      },
      formatterDateDepot(dateDepot: string): string {
        if (isNaN(Date.parse(dateDepot))) {
          return '';
        }
        return DateUtils.formaterDateShortISO(new Date(dateDepot));
      },
    },
  });
